import MainContent from '@/layouts/MainContent';
import { Tabs } from 'antd';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import EmailTemplateTab from './components/EmailTemplates';
import PdfTemplateTab from './components/PdfTemplateTab';
import SmsTemplateTab from './components/SmsTemplateTab';

const PAGE_TITLE = 'Manage templates';

export default function ManageTemplatePage() {
  const { t } = useTranslation();

  return (
    <MainContent title={t(PAGE_TITLE)}>
      <Helmet title={t(PAGE_TITLE)} />
      <div className="ant-layout-content-body">
        <Tabs>
          <Tabs.TabPane tab={t('Email templates')} key={'email-template'}>
            <EmailTemplateTab />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('Pdf templates')} key={'pdf-template'}>
            <PdfTemplateTab />
          </Tabs.TabPane>
          <Tabs.TabPane tab={'SMS templates'} key={'sms-template'}>
            <SmsTemplateTab />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </MainContent>
  );
}
